import { PageContainer } from '~/components/elements/PageContainer/PageContainer';
import React, { useEffect } from 'react';
import { sendEventToLogingress } from '~/utils/logingress/smartphoneMonshinLogingress';

export const ErrorNotfound: React.FC = () => {
  useEffect(() => {
    sendEventToLogingress('page_not_found');
  }, []);

  return (
    <PageContainer title="お探しのページが見つかりませんでした。" hideHeader>
      もう一度お試しください
    </PageContainer>
  );
};
